import { render, staticRenderFns } from "./single-application.vue?vue&type=template&id=c19db842&scoped=true&"
import script from "./single-application.vue?vue&type=script&lang=js&"
export * from "./single-application.vue?vue&type=script&lang=js&"
import style0 from "./single-application.vue?vue&type=style&index=0&id=c19db842&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c19db842",
  null
  
)

export default component.exports